module.exports = __webpack_public_path__ + "img/document.58df4204.svg";